module.exports = __webpack_public_path__ + "media/images/city/066-colosseum-e1da8a709cb7eac880c8cc16f843342b.svg";